/**
 * 当前插件仅在收藏按钮组件中使用
 */

export default {
  computed: {
    iconSrcType1(){
      return this.options.iconSrcType1 ? Number(this.options.iconSrcType1) : 0
    },
    getTextContent1(){
      let content1, textLimitLines, iconSrc, showIcon = false, iconPosition, iconMargin, contentHasLimit, iconColorIsThemeColor, iconColor, iconWidth,boxShadowH, boxShadowV, boxShadowBlur, boxShadowSpread, boxShadowColor,colorArr, textIsThemeColor, color,padding1, paddingTypeFlag, paddingTop, paddingRight, paddingBottom, paddingLeft,textAlign1
      switch (this.iconSrcType1) {
        case 0:
          content1 = this.options.content
          textLimitLines = this.options.textLimitLines
          iconSrc = this.options.iconSrc
          showIcon = this.options.showIcon
          iconPosition = this.options.iconPosition
          iconMargin = this.options.iconMargin
          contentHasLimit = this.options.contentHasLimit
          iconColorIsThemeColor = this.options.iconColorIsThemeColor
          iconColor = this.options.iconColor
          iconWidth = this.options.iconWidth
          boxShadowH = this.options.boxShadowH
          boxShadowV = this.options.boxShadowV
          boxShadowBlur = this.options.boxShadowBlur
          boxShadowSpread = this.options.boxShadowSpread
          boxShadowColor = this.options.boxShadowColor
          colorArr = this.checkAndSetPrimaryVal(this.options, "colorArr", "colorArr", "{}")
          textIsThemeColor = this.options.textIsThemeColor
          color = this.options.color
          padding1 = this.options.padding
          paddingTypeFlag = this.options.paddingTypeFlag
          paddingTop = this.options.paddingTop
          paddingRight = this.options.paddingRight
          paddingBottom = this.options.paddingBottom
          paddingLeft = this.options.paddingLeft
          textAlign1 = this.options.textAlign
          break
        case 1:
          content1 = this.activeButton ? this.options.contentActive : this.options.content
          textLimitLines = (this.activeButton || this.options.hoverIsSameActive)
              ? this.options.activeTextLimitLines
              : this.options.hoverTextLimitLines
          iconSrc = this.options.hoverIsSameActive
              ? this.options.clickIconSrc
              : this.options.hoverIconSrc
          showIcon = this.options.hoverIsSameActive
              ? this.options.activeShowIcon
              : this.options.hoverShowIcon
          iconPosition = this.options.hoverIsSameActive
              ? this.options.activeIconPosition
              : this.options.hoverIconPosition
          iconMargin = this.options.hoverIsSameActive
              ? this.options.activeIconMargin
              : this.options.hoverIconMargin
          contentHasLimit = this.options.hoverIsSameActive
              ? this.options.activeContentHasLimit
              : this.options.hoverContentHasLimit
          iconColorIsThemeColor = this.options.hoverIsSameActive
              ? this.options.activeIconColorIsThemeColor
              : this.options.hoverIconColorIsThemeColor
          iconColor = this.options.hoverIsSameActive
              ? this.options.activeIconColor
              : this.options.hoverIconColor
          iconWidth = this.options.hoverIsSameActive
              ? this.options.activeIconWidth
              : this.options.hoverIconWidth
          boxShadowH = this.options.hoverIsSameActive ? this.options.activeBoxShadowH : this.options.hoverBoxShadowH
          boxShadowV = this.options.hoverIsSameActive ? this.options.activeBoxShadowV : this.options.hoverBoxShadowV
          boxShadowBlur = this.options.hoverIsSameActive ? this.options.activeBoxShadowBlur : this.options.hoverBoxShadowBlur
          boxShadowSpread = this.options.hoverIsSameActive ? this.options.activeBoxShadowSpread : this.options.hoverBoxShadowSpread
          boxShadowColor = this.options.hoverIsSameActive ? this.options.activeBoxShadowColor : this.options.hoverBoxShadowColor
          colorArr = this.options.hoverIsSameActive
              ? this.checkAndSetPrimaryVal(this.options, "activeColorArr", "activeColorArr", "{}")
              : this.checkAndSetPrimaryVal(this.options, "hoverColorArr", "hoverColorArr", "{}")
          textIsThemeColor = this.options.hoverIsSameActive
              ? this.options.activeTextIsThemeColor
              : this.options.hoverTextIsThemeColor
          color = this.options.hoverIsSameActive
              ? this.options.activeColor
              : this.options.hoverColor
          padding1 = this.options.hoverIsSameActive ? this.options.activePadding : this.options.hoverPadding
          paddingTypeFlag = this.options.hoverIsSameActive ? this.options.activePaddingTypeFlag : this.options.hoverPaddingTypeFlag
          paddingTop = this.options.hoverIsSameActive ? this.options.activePaddingTop : this.options.hoverPaddingTop
          paddingRight = this.options.hoverIsSameActive ? this.options.activePaddingRight : this.options.hoverPaddingRight
          paddingBottom = this.options.hoverIsSameActive ? this.options.activePaddingBottom : this.options.hoverPaddingBottom
          paddingLeft = this.options.hoverIsSameActive ? this.options.activePaddingLeft : this.options.hoverPaddingLeft
          textAlign1 = this.options.hoverIsSameActive ? this.options.activeTextAlign : this.options.hoverTextAlign
          break
        case 2:
          content1 = this.options.contentActive
          textLimitLines = this.options.activeTextLimitLines
          iconSrc = this.options.clickIconSrc
          showIcon = this.options.activeShowIcon
          iconPosition = this.options.activeIconPosition
          iconMargin = this.options.activeIconMargin
          contentHasLimit = this.options.activeContentHasLimit
          iconColorIsThemeColor = this.options.activeIconColorIsThemeColor
          iconColor = this.options.activeIconColor
          iconWidth = this.options.activeIconWidth
          boxShadowH = this.options.activeBoxShadowH
          boxShadowV = this.options.activeBoxShadowV
          boxShadowBlur = this.options.activeBoxShadowBlur
          boxShadowSpread = this.options.activeBoxShadowSpread
          boxShadowColor = this.options.activeBoxShadowColor
          colorArr = this.checkAndSetPrimaryVal(this.options, "activeColorArr", "activeColorArr", "{}")
          textIsThemeColor = this.options.activeTextIsThemeColor
          color = this.options.activeColor
          padding1 = this.options.activePadding
          paddingTypeFlag = this.options.activePaddingTypeFlag
          paddingTop = this.options.activePaddingTop
          paddingRight = this.options.activePaddingRight
          paddingBottom = this.options.activePaddingBottom
          paddingLeft = this.options.activePaddingLeft
          textAlign1 = this.options.activeTextAlign
          break
        default:
          content1 = this.options.content
          textLimitLines = this.options.textLimitLines
          iconSrc = this.options.iconSrc
          showIcon = this.options.showIcon
          iconPosition = this.options.iconPosition
          iconMargin = this.options.iconMargin
          contentHasLimit = this.options.contentHasLimit
          iconColorIsThemeColor = this.options.iconColorIsThemeColor
          iconColor = this.options.iconColor
          iconWidth = this.options.iconWidth
          boxShadowH = this.options.boxShadowH
          boxShadowV = this.options.boxShadowV
          boxShadowBlur = this.options.boxShadowBlur
          boxShadowSpread = this.options.boxShadowSpread
          boxShadowColor = this.options.boxShadowColor
          colorArr = this.checkAndSetPrimaryVal(this.options, "colorArr", "colorArr", "{}")
          textIsThemeColor = this.options.textIsThemeColor
          color = this.options.color
          padding1 = this.options.padding
          paddingTypeFlag = this.options.paddingTypeFlag
          paddingTop = this.options.paddingTop
          paddingRight = this.options.paddingRight
          paddingBottom = this.options.paddingBottom
          paddingLeft = this.options.paddingLeft
          textAlign1 = this.options.textAlign
      }
      return {
        content1: content1,
        textLimitLines1: textLimitLines,
        iconSrc1: iconSrc,
        showIcon1: showIcon,
        iconPosition1: iconPosition,
        iconMargin1: iconMargin,
        contentHasLimit1: contentHasLimit,
        iconColorIsThemeColor1: iconColorIsThemeColor,
        iconColor1: iconColor,
        iconWidth1: iconWidth,
        boxShadowH1: boxShadowH,
        boxShadowV1: boxShadowV,
        boxShadowBlur1: boxShadowBlur,
        boxShadowSpread1: boxShadowSpread,
        boxShadowColor1: boxShadowColor,
        colorArr1: colorArr,
        textIsThemeColor1: textIsThemeColor,
        color1: color,
        padding1: padding1,
        paddingTypeFlag1:paddingTypeFlag,
        paddingTop1:paddingTop,
        paddingRight1:paddingRight,
        paddingBottom1: paddingBottom,
        paddingLeft1: paddingLeft,
        textAlign1: textAlign1,
      }
    },
    getTextContent_content(){
      return this.getTextContent1.content1
    },
    getTextContent_textLimitLines(){
      return this.getTextContent1.textLimitLines1
    },
    getTextContent_iconSrc(){
      return this.getTextContent1.iconSrc1
    },
    getTextContent_showIcon(){
      return this.getTextContent1.showIcon1
    },
    getTextContent_iconPosition(){
      return this.getTextContent1.iconPosition1
    },
    getTextContent_iconMargin(){
      return this.getTextContent1.iconMargin1
    },
    getTextContent_contentHasLimit(){
      return this.getTextContent1.contentHasLimit1
    },
    getTextContent_iconColorIsThemeColor(){
      return this.getTextContent1.iconColorIsThemeColor1
    },
    getTextContent_iconColor(){
      return this.getTextContent1.iconColor1
    },
    getTextContent_iconWidth(){
      return this.getTextContent1.iconWidth1
    },
    getTextContent_boxShadowH(){
      return this.getTextContent1.boxShadowH1
    },
    getTextContent_boxShadowV(){
      return this.getTextContent1.boxShadowV1
    },
    getTextContent_boxShadowBlur(){
      return this.getTextContent1.boxShadowBlur1
    },
    getTextContent_boxShadowSpread(){
      return this.getTextContent1.boxShadowSpread1
    },
    getTextContent_boxShadowColor(){
      return this.getTextContent1.boxShadowColor1
    },
    getTextContent_colorArr(){
      return this.getTextContent1.colorArr1
    },
    getTextContent_textIsThemeColor(){
      return this.getTextContent1.textIsThemeColor1
    },
    getTextContent_color(){
      return this.getTextContent1.color1
    },
    getTextContent_padding(){
      return this.getTextContent1.padding1
    },
    getTextContent_paddingTypeFlag(){
      return this.getTextContent1.paddingTypeFlag1
    },
    getTextContent_paddingTop(){
      return this.getTextContent1.paddingTop1
    },
    getTextContent_paddingRight(){
      return this.getTextContent1.paddingRight1
    },
    getTextContent_paddingBottom(){
      return this.getTextContent1.paddingBottom1
    },
    getTextContent_paddingLeft(){
      return this.getTextContent1.paddingLeft1
    },
    getTextContent_textAlign(){
      return this.getTextContent1.textAlign1
    }
  },
  mounted() {
    console.log("收藏插件的内容")
  }
}
